const settings = {
	backendUrl: process.env.VUE_APP_BACKEND_URL,
};

export default settings;
